import { Text } from '@chakra-ui/react';
import {
  IconSellMore,
  IconIncreaseDisclosure,
  IconWinCustomers,
} from './ReasonsIcons';

const TextWinCustomers = () => (
  <Text pb={2} as="span">
    Fornecedores que indicam a Inventa ganham maior destaque em nosso site e nas
    comunicações com nossa base.
  </Text>
);

const TextSellMore = () => (
  <Text pb={2} as="span">
    Fornecedores que indicam lojistas vendem até 6x mais do que aqueles que não
    indicam.
  </Text>
);

const TextIncreaseDisclosure = () => (
  <Text pb={2} as="span">
    Marcas que mais vendem tornam-se mais presentes no discurso comercial de
    nossa equipe de prospecção e em nossas ações de marketing.
  </Text>
);

export const reasonsTexts = [
  {
    title: 'Aumente sua exposição na Inventa',
    body: <TextWinCustomers />,
    icon: <IconWinCustomers />,
  },
  {
    title: 'Venda até 6x mais',
    body: <TextSellMore />,
    icon: <IconSellMore />,
  },
  {
    title: 'Fortaleça sua marca fora da Inventa',
    body: <TextIncreaseDisclosure />,
    icon: <IconIncreaseDisclosure />,
  },
];
